import useCartState from '@order/hooks/useCartState'
import usePayments from '@order/hooks/usePayments'
import { useOrderState } from '@order/hooks/useOrderState'
import { trpc } from 'api'
import { useCallback } from 'react'
import { replaceWithDismiss } from 'providers/AuthRedirect'
import useIntroStore from './useIntroStore'
import { useCustomer, useSession } from './useSession'
import { useStagesStore } from './useStagesStore'
import { useAvatarSessionEnd } from 'features/avatar/speech/useAvatarSession'

// Stateless logout without cleanup, try not use except for invalid
export const invalidateSession = () => {
  const sessionState = useSession.getState()
  const orderState = useOrderState.getState()
  sessionState.endSession()
  orderState.reset()
  usePayments.getState().reset()
}

export const useLogout = (options?: { navigate?: boolean }) => {
  const navigate = options?.navigate ?? true
  const endSession = useSession((state) => state.endSession)
  const resetOrder = useOrderState((state) => state.reset)
  const resetCart = useCartState((state) => state.reset)
  const resetPayments = usePayments((state) => state.reset)
  const info = useSession((s) => s.info)
  const customer = useCustomer()
  const { mutate: logoutMutation } = trpc.customer.logout.useMutation()
  const { reset: resetIntroStore } = useIntroStore()
  const resetStages = useStagesStore((state) => state.reset)
  const { end: endAvatarSession } = useAvatarSessionEnd()
  // const utils = trpc.useUtils()

  const logout = useCallback(() => {
    if (customer) {
      logoutMutation({
        info,
        customer,
      })
    }
    if (navigate) {
      replaceWithDismiss('/')
    }
    endAvatarSession()
    endSession()
    resetOrder()
    resetIntroStore()
    resetCart()
    resetPayments()
    resetStages()
  }, [
    logoutMutation,
    customer,
    endSession,
    resetOrder,
    endAvatarSession,
    info,
    navigate,
    resetIntroStore,
    resetCart,
    resetPayments,
    resetStages,
    logoutMutation,
  ])

  return logout
}

export const useLogoutStore = () => {
  const logout = useLogout()
  const setStoreLogin = useSession((s) => s.setStoreLogin)
  const setStore = useSession((s) => s.setStore)

  const resetStore = useCallback(() => {
    setStoreLogin('')
    setStore(null)
  }, [setStoreLogin, setStore])

  const logoutStore = useCallback(() => {
    logout()
    resetStore()
  }, [logout, resetStore])

  return logoutStore
}
